<template>
  <div class="h-full relative">
    <div class="m-16 h-full">
      <router-view />
    </div>
  </div>
</template>
